export interface ClearTagsButtonProps extends ClearButtonBaseProps {
  className?: string;
  type: ClearButtonType;
}

export enum ClearButtonType {
  BUTTON = 'BUTTON',
  CHIP = 'CHIP',
  ICON_BUTTON = 'ICON_BUTTON',
}

export interface ClearButtonBaseProps {
  onClick: VoidFunction;
  text?: string;
  count?: number;
}
